// import react components
import { createContext } from "react";

const ExplanationDataContext = createContext();

export default ExplanationDataContext;
